import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, DoCheck, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IMultiSelectItem } from '@app/ui/option-multi-select/multi-select-item.interface';
import { Setting } from '@app/reports/report-settings/setting.model';
import { getIdentifierForIterableItem } from '@app/shared/trackby.service';

const dragDropThreshold = 10;

@Component({
  selector: 'acs-option-multi-select',
  templateUrl: './option-multi-select.component.html',
  styleUrls: ['./option-multi-select.component.scss']
})
export class OptionMultiSelectComponent implements OnInit, DoCheck {
  @Input() setting: Setting;
  @Output() itemMovedEvent = new EventEmitter();

  public available: IMultiSelectItem[] = [];
  public selected: IMultiSelectItem[] = [];
  public searchText = '';
  public jumpFocus: string;
  public getIdentifierForIterableItem = getIdentifierForIterableItem;

  constructor() {}

  ngOnInit(): void {
    this.updateLists();
    this.jumpFocus = 'searchText';
  }

  ngDoCheck(): void {
    if (
      JSON.stringify(this.setting.options.filter((x) => x.selected)) !==
      JSON.stringify(this.selected)
    ) {
      this.filterList();
    }
  }

  public drop(event: CdkDragDrop<string[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );

      this.available.forEach((x) => (x.selected = false));
      this.selected.forEach((x) => (x.selected = true));
      this.itemMovedEvent.emit();
    }
  }

  public updateLists(): void {
    this.available = this.setting.options.filter((x) => !x.selected);
    this.selected = this.setting.options.filter((x) => x.selected);
  }

  public filterList(): void {
    if (this.searchText.length > 0) {
      this.available = this.setting.options.filter(
        (x) => !x.selected && x.name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    } else {
      this.updateLists();
    }
    this.itemMovedEvent.emit();
  }

  public showDragDropSection(): boolean {
    return this.setting.options.length > dragDropThreshold || this.setting.showDragDrop;
  }

  public clearInput(): void {
    this.searchText = '';
    this.updateLists();
  }

  public selectOption(): void {
    const matchingOption = this.setting.options.find(
      (x) => x.name.toLowerCase() === this.searchText.toLowerCase()
    );
    const filteredResult = this.setting.options.filter((x) =>
      x.name.toLowerCase().includes(this.searchText.toLowerCase())
    );

    if (matchingOption) {
      matchingOption.selected = !matchingOption.selected;
      this.searchText = '';
    } else if (filteredResult.length === 1) {
      filteredResult[0].selected = !filteredResult[0].selected;
      this.searchText = '';
    }

    this.updateLists();
  }
}
